/**
 * @chineseName Button 按钮
 * @subDescription m-ui组件 按钮
 */
import Button from './button';
export default Button;